import { motion } from "framer-motion";
import ds from "./img/DSC_0296.png";
import ds1 from "./img/dsc.png";
import holy from "../img/224.jpg";
import kok from "../images/IMG_5531.JPG";
import kok1 from "../images/DSC_0062.JPG";
import kok2 from "../img/332.jpg";

const His = () => {
  const contentBlocks = [
    {
      image: kok,
      imageAlt: "His Holiness ceremonial portrait",
      overlayImage: kok2,
      overlayAlt: "His Holiness banner portrait",
      paragraphs: [
        "His Holiness Olumba Olumba Obu is presented as divinely appointed to royal responsibility, invested in sacred authority and mission stewardship within the Kingdom.",
        "His role reflects predestination, disciplined service, and complete alignment with the divine purpose guiding the Brotherhood.",
      ],
    },
    {
      image: ds1,
      imageAlt: "His Holiness leadership scene",
      overlayImage: holy,
      overlayAlt: "Kingdom governance placeholder",
      paragraphs: [
        "His coronation and elevation established a clear administrative mandate, placing him at the center of governance for the Brotherhood of the Cross and Star.",
        "Through spiritual unity with the Father, he provides direction, policy guidance, and institutional oversight across the Kingdom structure.",
      ],
    },
    {
      image: ds,
      imageAlt: "His Holiness ministry expansion",
      overlayImage: kok1,
      overlayAlt: "Global kingdom work placeholder",
      paragraphs: [
        "The growth and expansion of the Kingdom mission are entrusted to his leadership through appointments, oversight, welfare administration, and strategic decision-making.",
        "This mandate supports spiritual order, organizational continuity, and the practical advancement of mission work across local and international communities.",
      ],
    },
  ];

  return (
    <motion.main
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1.1,
        delay: 0.2,
        ease: [0, 0.71, 0.2, 1.01],
      }}
      className="relative z-0 w-full bg-white text-slate-900"
    >
      <header className="relative z-0 pt-24 mt-24 md:pt-32 px-6 md:px-20 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[20px] h-[20px] rounded-full bg-blue-200/40 blur-[10px]" />
          <div className="absolute bottom-0 left-1/4 w-[10px] h-[10px] rounded-full bg-blue-100/50 blur-[10px]" />
          <div className="absolute bottom-0 right-1/4 w-[10px] h-[10px] rounded-full bg-indigo-100/50 blur-[10px]" />
        </div>

        <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="inline-flex items-center gap-4"
          ></motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="space-y-4"
          >
            <h1 className="text-4xl md:text-6xl font-black text-stone-900 tracking-tighter leading-none uppercase">
              His Holiness{" "}
              <span className="text-red-600 italic">Olumba Olumba Obu</span>
            </h1>
            <p className="text-stone-500 text-base md:text-xl font-medium leading-relaxed max-w-3xl mx-auto">
              The King of Kings and Lord of Lords <br /> Leader, Universal
              Theocratic Council <br /> Head of Administration, BCS Worldwide
            </p>
          </motion.div>
        </div>
      </header>

      <section className="px-6 md:px-20 py-16 md:py-28 space-y-28">
        {contentBlocks.map((block, index) => {
          const isOdd = index % 2 !== 0;
          const overlayAlignmentClass = isOdd ? "-left-10" : "-right-10";

          return (
            <article
              key={block.title}
              className="grid md:grid-cols-2 gap-14 md:gap-24 items-center"
            >
              <div className={isOdd ? "md:order-2" : ""}>
                <div className="relative">
                  <img
                    src={block.image}
                    alt={block.imageAlt}
                    className="w-full h-[300px] md:h-[420px] object-cover border border-slate-300"
                  />
                  <img
                    src={block.overlayImage}
                    alt={block.overlayAlt}
                    className={`hidden md:block absolute -bottom-10 ${overlayAlignmentClass} w-[46%] h-[180px] object-cover border-4 border-white shadow-xl`}
                  />
                </div>
              </div>

              <div className={`${isOdd ? "md:order-1" : ""} md:px-6 lg:px-10`}>
                <h2 className="text-2xl md:text-4xl leading-tight font-semibold text-slate-900">
                  {block.title}
                </h2>
                <div className="mt-6 space-y-4 text-base md:text-lg leading-relaxed text-slate-700">
                  {block.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </article>
          );
        })}
      </section>
    </motion.main>
  );
};

export default His;
